import Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';

import { calculateTime, formatTime } from '../../utils/helper';

HC_accessibility(Highcharts);

const SnowChart = ({ timeSeries, chartTitle, yAxisTitle, type }) => {
  const data = timeSeries?.site?.time_series_container || {};
  if (!data) return null;

  type === 'rate' ? data.series_snow_rate_inches : data.series_snow_accum_total_inches || [];
  const snow = data.series_snow_accum_total_inches || [];

  const epochStart = parseInt(data.epoch_start_time, 10);
  const firstDelta = parseInt(data.first_time_delta_seconds, 10);
  const interval = parseInt(data.remaining_time_delta_seconds, 10);

  const seriesData = snow.map((_, index) => ({
    x: calculateTime(index, epochStart, firstDelta, interval),
    snow: snow[index],
  }));

  const options = {
    accessibility: {
      enabled: true,
    },
    chart: {
      type: 'line',
      height: 250,
      zoomType: 'x',
      panning: true,
      panKey: 'shift',
    },
    title: {
      align: 'left',
      text: chartTitle,
    },
    subtitle: {
      align: 'left',
      text: 'Click chart and drag to zoom',
    },
    xAxis: {
      type: 'datetime',
      labels: {
        formatter: function () {
          return formatTime(this.value / 1000);
        },
      },
      tickInterval: 12 * 3600 * 1000,
    },
    yAxis: {
      visible: true,
      title: {
        text: yAxisTitle,
      },
      labels: {
        enabled: true,
      },
      gridLineWidth: 0,
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false,
        },
        enableMouseTracking: true,
      },
      series: {
        states: {
          inactive: {
            opacity: 1,
          },
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        let tooltipHtml = `<div>Time: ${formatTime(this.x / 1000)}<br/><ul>`;

        this.points.forEach((point) => {
          tooltipHtml += `<li><span style="color:${point.series.color}">${point.series.name}: </span><strong>${point.y}</strong></li>`;
        });

        tooltipHtml += '</ul></div>';
        return tooltipHtml;
      },
      positioner: function (labelWidth, labelHeight, point) {
        const chartWidth = this.chart.chartWidth;
        const chartHeight = this.chart.chartHeight;
        const tooltipX = point.plotX + this.chart.plotLeft - labelWidth / 2;
        const tooltipY = point.plotY + this.chart.plotTop - labelHeight - 10;

        return {
          x: Math.max(0, Math.min(tooltipX, chartWidth - labelWidth)),
          y: Math.max(0, Math.min(tooltipY, chartHeight - labelHeight)),
        };
      },
      zIndex: 1000,
    },
    series: [
      {
        name: chartTitle,
        data: seriesData.map((point) => [point.x, point.snow]),
        color: '#0000FF',
      },
    ],
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      floating: false,
      backgroundColor: '#FFFFFF',
      itemStyle: {
        color: '#333333',
      },
      itemHoverStyle: {
        color: '#000000',
      },
    },
  };

  return (
    <div className="mb-10">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default SnowChart;
